module.exports = __webpack_public_path__ + "static/logo-4b1916c2e96dbb867d1165e7c5a24206.svg";